// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","662":"29107295","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"c5b771ab70aba4bf6327","662":"96551b17fff61ef6cc9f","691":"ce53bd4a0ab010300254"}[chunkId] + ".js";
};